<div class="modal-header dialog-header">
  <div class="headerTitle">
    <div class="dialog-title">{{showData.headerTitle}}</div>
  </div>
  <div class="headerIcon float-right">
    <i class="fa fa-times" (click)="closeDialog()"></i>
  </div>
</div>
<div class="container dialog-container modal-body">
  <div class="dispText">{{showData.confirmMsg}}</div>
</div>
<div class="actions dialog-actions modal-footer">
  <button class="btn-default cancelBtn" (click)="closeDialog()">{{showData.cancelButtonText}}</button>
  <button class="btn-default confirmBtn" (click)="confirmSuccess()" cdkFocusInitial>{{showData.confirmButtonText}}</button>
</div>